module.exports = __webpack_public_path__ + "static/media/login-app-teaser-mini-v2.88a90e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-app-teaser-mini-v2.jpg
// module id = 1723
// module chunks = 0